export interface LockdownState {
	staleDataModalVisible: boolean;
	staleData: StaleConfigurationData[];
	lockdownConfigurationPayload: UpdateLockdownDetailsPayload;
	lockdownConfiguration: LockdownConfiguration;
	lockdownConfigurations: LockdownConfigurationByDesignation[];
	lockdownModalVisible: boolean;
	selectedClearanceLevel: ClearanceLevel
}

export enum ClearanceLevel {
	Unset = 0,
	Level_1,
	Level_2,
	Level_3,
	Level_4,
	Level_5,
	Level_6
}

export interface LockdownConfiguration {
	groupId: number;
	serverId: number;
    serverTypeId: number;
	updateReason?: string;
	availableClearanceLevels: ClearanceLevel[];
	cCureClearanceStates: CCureClearanceState[];
}

export interface LockdownConfigurationByDesignation
{
	groupId: number;
	isDesignated: boolean;
	clearanceFilterLevel: number;
	name: string;
	selected: boolean;
	serverTitle: string;
	availableClearanceLevels: ClearanceLevel[];
	cCureClearanceStates: CCureClearanceState[];
}

export interface LockdownConfigurationByDesignationNewCFL extends LockdownConfigurationByDesignation {
	newClearanceLevel: ClearanceLevel
}

export interface CCureClearanceState {
	name: string;
	fullName: string;
	ccureClusterId: string;
	ccureIdentifier: string;
	serverTitle: string;
	designated: boolean;
	xfEventClearanceLevel: ClearanceLevel;
	active: boolean;
	enabledByDefault: boolean;
	enabled: boolean;
}

export interface UpdateLockdownDetailsPayload {
	lockdownConfiguration: LockdownConfiguration;
	updatedLockdownClearanceLevels: UpdatedLockdownClearanceByName[];
	checkStaleData: boolean;
}

export interface UpdatedLockdownClearanceByName {
	name: string;
	level: ClearanceLevel
}

export interface GetReaderGroupsResponse {
    success: boolean;
    error: string;
    readerGroups: ReaderGroup[];
}

export interface DesignatedSearchOption {
	searchDesignated: boolean;
	searchUndesignated: boolean;
}

export interface Reader {
	defaultClearanceFilterLevel: number;
	id: string;
	name: string;
	objectID: number;
	type: string;
}

export interface Door {
	doorID: string;
	inReaderID: string;
	outReaderID: string;
}

export interface ReaderGroupDoor {
	readerGroup: string;
	title: string;
	doorID: string;
	deviceID: number;
	CFL: number;
}

export interface ReaderGroup {
	defaultClearanceFilterLevel: number;
	extraValue: string;
	id: string;
	name: string;
	objectID: number;
	readers: Reader[];
	doors: Door[];
	selected: boolean;
	type: string;
	isDesignated: boolean;
}

export interface UpdateReaderGroupsPayload {
	groupID: number;
	updatedReaderGroups: ReaderGroup[];
	reason?: string;
}

export interface UpdateReaderGroupsCFLResponse
{
	success: boolean;
	error: string;
}

export interface GetDevicesByExtraValuesPayload {
	extraValues: string;
}

export interface StaleConfigurationData {
	lockdownConfiguration: LockdownConfigurationByDesignation;
	newClearanceLevel: number;
}

export enum ClearanceFilterLevel {
	Level_One = 1,
	Level_Two = 2,
	Level_Three = 3,
	Level_Four = 4,
	Level_Five = 5,
	Level_Six = 6
}

export const ClearanceFilterLevels: number[] = [
	ClearanceFilterLevel.Level_One,
	ClearanceFilterLevel.Level_Two,
	ClearanceFilterLevel.Level_Three,
	ClearanceFilterLevel.Level_Four,
	ClearanceFilterLevel.Level_Five,
	ClearanceFilterLevel.Level_Six
];
